import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Category, PageMeta } from 'domain/types';
import { CategoriesRepo, PageMetaRepo } from 'domain/repositories';
import Layout from 'components/layout/Layout';
import CategoryNavigation from 'components/shop/CategoryNavigation/CategoryNavigation';
import { DEFAULT_CATEGORY, REVALIDATES } from 'domain/constants';

interface ShopPageProps {
  categories: Array<Category>;
  pageMeta: PageMeta;
}

const ShopPage: React.FC<ShopPageProps> = ({ categories, pageMeta }): JSX.Element => {
  const router = useRouter();
  useEffect(() => {
    if (categories.length) {
      const defaultCategory = categories.find(({ slug }) => slug === DEFAULT_CATEGORY);
      if (defaultCategory) router.push(`shop/${DEFAULT_CATEGORY}`);
      else router.push(`/shop/${categories[0].slug}`);
    }
  }, []);

  return (
    <Layout pageMeta={pageMeta}>
      <CategoryNavigation categories={categories} />
    </Layout>
  );
};

export const getStaticProps = async () => {
  try {
    const [categories, pageMeta] = await Promise.all([
      CategoriesRepo.get(),
      PageMetaRepo.getBySlug('shop')
    ]);

    return {
      props: {
        categories,
        pageMeta
      },
      revalidate: REVALIDATES.shop
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);

    return {
      notFound: true,
      revalidate: REVALIDATES.shop
    };
  }
};

export default ShopPage;
